<template>
  <div class="dlrLayer slideMiddle_in">
    <div class="dlrLayer-middle">
      <div class="dlrMiddlePopup">
        <a
          href="javascript:void(0);"
          class="dlrMiddlePopup-close"
          @click="close"
        ></a>
        <div class="dlrMiddlePopup-title">
          <h3 class="dlrGetWXB-title">客户已同意添加微信，以下为手机号码</h3>
        </div>
        <div class="dlrMiddlePopup-content">
          <div class="dlrGetWXB-copy">
            <p ref="phoneEl">{{ phone }}</p>
            <a
              v-stat:show="{
                action: 'dlr_vr_page_copy_buttom_show',
                extend: { channelId },
              }"
              v-stat:click="{
                action: 'dlr_vr_page_copy_buttom_click',
                extend: { channelId },
              }"
              class="dlrGetWXB-copy-btn"
              href="javascript:void(0);"
              @click="copyPhone"
            >复制</a>
          </div>
        </div>
        <div class="dlrMiddlePopup-buttons">
          <a
            href="javascript:void(0);"
            class="dlrMiddlePopup-button dlrGetWXB-btn-bg"
            @click="close"
          >我知道了</a>
        </div>
        <p class="dlrGetWXB-tip">可进入i 车商app-带看任务中查看手机号码</p>
      </div>
    </div>
    <div class="dlrLayer-mask"   @click="close"></div>
  </div>
</template>
<script lang="js">
import { defineComponent } from 'vue-demi';
import layManager from '../../services/layer.manager';
import * as layerNames from '../../services/layerName';
import store from '../../store';
import util from '../../utils/util';
export default defineComponent({
    props:{
      phone:{
        type: String,
        required: true
      }
    },
    data () {
      return { channelId: store.state.sales.vrSalesInfo.channelId }
    },
    methods:{
      copyPhone() {
        if (util.copy(this.$refs.phoneEl)) {
          layManager.toast({ message: '复制手机号成功！' }, 1000);
        } else {
          layManager.toast({ message: '复制手机号失败，请手动选择！' }, 1000);
        }
      },
      close(){
        layManager.close(layerNames.SALE_WE_CHAT_PHONE);
      }
    }
})
</script>

<style lang="scss">
@import '@/assets/scss/modules/_VRGetWXB.scss';
</style>
